import { jsPDF } from 'jspdf'
import html2canvas from 'html2canvas'

export async function exportChartPdf(node: HTMLElement, title = 'Chart') {
  const pdf = new jsPDF({
    unit: 'pt',
    format: 'a4',
    orientation: 'portrait',
  })

  const canvas = await html2canvas(node, {
    scale: 2,
    backgroundColor: '#ffffff',
    useCORS: true,
  })

  const img = canvas.toDataURL('image/png')
  const pageWidth = pdf.internal.pageSize.getWidth()
  const ratio = canvas.height / canvas.width
  const imgHeight = pageWidth * ratio

  pdf.text(title, 20, 30)
  pdf.addImage(img, 'PNG', 0, 50, pageWidth, imgHeight)

  pdf.save(`${title}.pdf`)
}

export function printChart(
  node: HTMLElement,
  title = 'Chart',
  orientation: 'portrait' | 'landscape' = 'landscape'
) {
  const win = window.open('', '_blank')
  if (!win) return

  const doc = win.document
  doc.write(`
    <html>
      <head>
        <title>${title}</title>
        <style>
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          body { 
            margin: 0;
            padding: 20px;
            font-family: Arial;
          }
          h1 { 
            font-size: 20px;
            margin-bottom: 12px;
          }
          .chart-container { 
            width: 100%;
            page-break-inside: avoid;
          }
          img, canvas, svg { 
            max-width: 100%;
            height: auto;
            display: block;
          }
          @media print {
            html, body {
              width: 100%;
              height: 100%;
              margin: 0 !important;
              padding: 0 !important;
            }
            body {
              padding: 10mm !important;
            }
            .chart-container {
              page-break-inside: avoid;
              page-break-after: avoid;
            }
            @page {
              margin: 0;
              size: auto;
              /* Note: enabling orientation prevents user to select it in native browser window */
              /*size: ${orientation === 'portrait' ? 'A4 portrait' : 'A4 landscape'};*/
            }
          }
        </style>
      </head>
      <body>
        <h1>${title}</h1>
        <div class="chart-container"></div>
      </body>
    </html>
  `)

  const container = doc.querySelector('.chart-container')

  const clone = node.cloneNode(true) as HTMLElement
  clone.querySelectorAll('.no-print').forEach((el) => el.remove())

  clone.style.height = 'auto'
  clone.style.minHeight = 'auto'
  clone.style.maxHeight = 'none'

  container?.appendChild(clone)
  doc.close()

  win.addEventListener('load', () => {
    win.print()
    win.close()
  })
}
